import React from 'react'
import PropTypes from 'prop-types'
import { Button, Hidden, makeStyles } from '@material-ui/core'
import { Pagination as MuiPagination } from '@material-ui/lab'

const useStyles = makeStyles((theme) => ({
  paginationBoundaryButton: {
    backgroundColor: theme.palette.primary.light,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 0,
    color: theme.palette.primary.main,
    height: 40,
    width: 126,
    '&:disabled': {
      backgroundColor: 'transparent',
      borderColor: '#1e25531f',
      color: theme.typography.body1.color,
    },
    [theme.breakpoints.down('xs')]: {
      width: 72,
    },
  },
  paginationList: {
    '& button': {
      backgroundColor: theme.palette.primary.light,
      borderColor: '#707070',
      borderRadius: 0,
      borderRightWidth: 0,
      color: theme.palette.primary.main,
      height: 40,
      margin: 0,
      width: 40,
      '&.Mui-selected': {
        borderRight: 0,
      },
    },
    '& li:last-of-type .Mui-selected': {
      borderRightWidth: 1,
      borderRightStyle: 'solid',
    },
    '& .MuiPaginationItem-root.MuiPaginationItem-ellipsis': {
      alignItems: 'center',
      borderLeft: `1px solid ${theme.palette.primary.main}`,
      borderRadius: 0,
      display: 'flex',
      height: 40,
      justifyContent: 'center',
      margin: 0,
      paddingLeft: 3,
      paddingRight: 3,
    },
  },
}))

const Pagination = ({ onPageRequest, pageNumber, totalPages }) => {
  const classes = useStyles()
  return (
    <div style={{ display: 'flex' }}>
      {/* To match design we had to implement our own Back/Next Buttons instead of relying on the
          MuiPagination Next/PrevButton*/}
      <Button
        className={classes.paginationBoundaryButton}
        disabled={pageNumber < 2}
        onClick={() => onPageRequest(pageNumber - 1)}
        style={{ borderRight: 0 }}
      >
        &lang;&lang;
        <Hidden xsDown>
          <span style={{ paddingLeft: 15 }}>Back</span>
        </Hidden>
      </Button>
      <MuiPagination
        classes={{ ul: classes.paginationList }}
        color="primary"
        count={totalPages}
        hideNextButton
        hidePrevButton
        onChange={(event, page) => onPageRequest(page)}
        page={pageNumber}
        size="medium"
        variant="outlined"
      />
      <Button
        className={classes.paginationBoundaryButton}
        disabled={pageNumber === totalPages}
        onClick={() => onPageRequest(pageNumber + 1)}
      >
        <Hidden xsDown>
          <span style={{ paddingRight: 15 }}>Next</span>
        </Hidden>
        &rang;&rang;
      </Button>
    </div>
  )
}

Pagination.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  onPageRequest: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
}

export default Pagination
